import { icon } from "@fortawesome/fontawesome-svg-core";
import { NumberBox, Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";

export default function ConfigureSafetyReporting() {
  const onClick = () => {};

  return (
    <>
      <Toolbar>
        <Item
          location="after"
          name="saveButton"
          options={{ icon: "save", onClick: onClick }}
          widget="dxButton"
        />
      </Toolbar>
      <div
        style={{
          // fontSize: "16px",
          fontWeight: "bold",
          color: "black",
          textTransform: "none",
        }}
      >
        Follow-up Report Count
      </div>
      <div
        style={{
          display: "flex",
          //   justifyContent: "space-between",
          marginTop: "16px",
        }}
      >
        <div>
          <NumberBox
            showSpinButtons={true}
            showClearButton={true}
            width={100}
          />
        </div>
        <div> times or more and less then</div>
        <div>
          <NumberBox
            showSpinButtons={true}
            showClearButton={true}
            width={100}
          />
        </div>
        <div> times</div>
      </div>
      <div
        style={{
          display: "flex",
          //   justifyContent: "space-between",
          marginTop: "16px",
        }}
      >
        <div>
          <NumberBox
            showSpinButtons={true}
            showClearButton={true}
            width={100}
          />
        </div>
        <div> or more</div>
      </div>
    </>
  );
}
